// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Button_buttonContainer__0MWME","Mui-disabled":"Button_Mui-disabled__Zte-S","outlined":"Button_outlined__-tAZi","CopyButton":"Button_CopyButton__98Brt"};